import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zh from './zh.js'
import en from './en.js'
import polish from './polish.js'
import spanish from './spanish.js'
import turkish from './turkish.js'
import dutch from './dutch.js'
import hungary from './hungary.js'
import zhtw from './zh-TW.js'
import ptbr from './pt-BR.js'
import germany from './germany.js'
import french from './french.js'
import italian from './italian.js'
import locale from 'element-ui/lib/locale'

Vue.use(VueI18n)

const DEFAULT_LANG = 'en'

const locales = {
  zh: zh,
  en: en,
  polish: polish,
  spanish: spanish,
  turkish: turkish,
  dutch: dutch,
  hungary: hungary,
  zhtw: zhtw,
  ptbr: ptbr,
  germany: germany,
  french: french,
  italian: italian
}

const i18n = new VueI18n({
  locale: location.hash.split('/')[1] || DEFAULT_LANG,
  messages: locales
})

export const setup = lang => {
  if (lang === undefined) {
    lang = location.hash.split('/')[1] || 'en'
    if (locales[lang] === undefined) {
      lang = DEFAULT_LANG
    }
  }
  Vue.config.lang = lang
  i18n.locale = lang
  locale.use(lang)
}

export default i18n



// WEBPACK FOOTER //
// ./src/widgets/i18n/index.js